const VALID_DEALER_CODE = new RegExp(/^[0-9]{5,7}$/);

export const dealerCodeValidator = (mobile) => {
    return VALID_DEALER_CODE.test((mobile));
};
